import { render, staticRenderFns } from "./GreenButton.vue?vue&type=template&id=24a3ce47&scoped=true"
import script from "./GreenButton.vue?vue&type=script&lang=js"
export * from "./GreenButton.vue?vue&type=script&lang=js"
import style0 from "./GreenButton.vue?vue&type=style&index=0&id=24a3ce47&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3ce47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a3ce47')) {
      api.createRecord('24a3ce47', component.options)
    } else {
      api.reload('24a3ce47', component.options)
    }
    module.hot.accept("./GreenButton.vue?vue&type=template&id=24a3ce47&scoped=true", function () {
      api.rerender('24a3ce47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/GreenButton.vue"
export default component.exports